import React from 'react';
import { Users } from 'lucide-react';

const Customers = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-96 bg-white rounded-lg shadow-sm border">
      <div className="text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Users className="h-8 w-8 text-blue-500" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Customer Management</h2>
        <p className="text-gray-600 mb-6">View and manage customer data from previous orders</p>
        <div className="inline-block px-6 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
          Coming Soon
        </div>
      </div>
    </div>
  );
};

export default Customers;